import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FileImportResultDialogData {
    title: string;
    headerText?: string;
    lines?: string[];
    isWarning?: boolean;
    message?: string;
}

@Component({
    selector: 'file-import-result-dialog',
    templateUrl: './file-import-result-dialog.component.html',
    styleUrls: ['./file-import-result-dialog.component.scss'],
    standalone: false
})
export class FileImportResultDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: FileImportResultDialogData,
        public dialogRef: MatDialogRef<FileImportResultDialogComponent>) {
    }
}
